import { render } from "./StatTile.vue?vue&type=template&id=2ce45cdc&scoped=true"
import script from "./StatTile.vue?vue&type=script&lang=js"
export * from "./StatTile.vue?vue&type=script&lang=js"

import "./StatTile.vue?vue&type=style&index=0&id=2ce45cdc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce45cdc"]])

export default __exports__